module.exports = __webpack_public_path__ + "img/service4EN.1125c7d1.svg";